import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useCollection } from "../hooks/useCollection";

const Clients = () => {
  const { items, loading } = useCollection("clients", "order", "asc");

  return (
    <section id="clients" className="clients section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Alliance</h2>
        </div>

        {loading ? (
          <div className="text-center text-muted py-4">กำลังโหลด...</div>
        ) : items.length === 0 ? (
          <div className="text-center text-muted py-4">ยังไม่มีโลโก้พันธมิตร</div>
        ) : (
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={3}
            pagination={{ clickable: true }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={items.length > 3}
            speed={300}
            effect="slide"
            breakpoints={{
              640: { slidesPerView: 2 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 6 },
            }}
          >
            {items.map((item) => (
              <SwiperSlide key={item.id}>
                <img
                  src={item.imageUrl}
                  className="img-fluid"
                  alt={item.name}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </section>
  );
};

export default Clients;
